import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import {
  SignerService,
  AssinanteResponseDTO,
} from '../../services/signer.service';

@Component({
  selector: 'app-signers-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TagModule,
    ToolbarModule,
    ConfirmDialogModule,
    ToastModule,
  ],
  providers: [MessageService, ConfirmationService],
  template: `
    <p-card>
      <ng-template pTemplate="header">
        <p-toolbar>
          <ng-template pTemplate="start">
            <h2>Lista de Assinantes</h2>
          </ng-template>
          <ng-template pTemplate="end">
            <p-button
              label="Recarregar"
              icon="pi pi-refresh"
              (onClick)="loadSigners()"
              [outlined]="true"
              severity="secondary"
              size="small"
              class="mr-2"
            >
            </p-button>
            <p-button
              label="Novo Assinante"
              icon="pi pi-plus"
              (onClick)="createSigner()"
              severity="primary"
            >
            </p-button>
          </ng-template>
        </p-toolbar>
      </ng-template>

      <ng-template pTemplate="content">
        <!-- Filtros -->
        <div class="filters-container p-3">
          <div class="p-grid p-align-center">
            <div class="p-col-12 p-md-6 p-lg-4">
              <span class="p-input-icon-left w-full">
                <i class="pi pi-search"></i>
                <input
                  pInputText
                  type="text"
                  placeholder="Buscar assinante..."
                  [(ngModel)]="searchTerm"
                  (input)="filterSigners()"
                  class="w-full"
                />
              </span>
            </div>

            <div class="p-col-12 p-md-6 p-lg-4">
              <p-select
                [(ngModel)]="statusFilter"
                [options]="statusOptions"
                (onChange)="filterSigners()"
                placeholder="Todos os Status"
                optionLabel="label"
                optionValue="value"
                [showClear]="true"
                class="w-full"
              >
              </p-select>
            </div>
          </div>
        </div>

        <!-- Tabela -->
        <p-table
          [value]="filteredSigners"
          [paginator]="true"
          [rows]="pageSize"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords} registros"
          [globalFilterFields]="['nomeAssinante', 'funcaoAssinante']"
          responsiveLayout="scroll"
          [loading]="isLoading"
          loadingIcon="pi pi-spin pi-spinner"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="nomeAssinante">
                Nome
                <p-sortIcon field="nomeAssinante"></p-sortIcon>
              </th>
              <th pSortableColumn="funcaoAssinante">
                Função
                <p-sortIcon field="funcaoAssinante"></p-sortIcon>
              </th>
              <th pSortableColumn="sequenciaAssinante">
                Sequência
                <p-sortIcon field="sequenciaAssinante"></p-sortIcon>
              </th>
              <th pSortableColumn="statusAssinante">
                Status
                <p-sortIcon field="statusAssinante"></p-sortIcon>
              </th>
              <th pSortableColumn="createdAt">
                Data Criação
                <p-sortIcon field="createdAt"></p-sortIcon>
              </th>
              <th style="width: 280px; min-width: 280px;">Ações</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-signer>
            <tr [class.opacity-50]="signer.deletedAt">
              <td>{{ signer.nomeAssinante }}</td>
              <td>{{ signer.funcaoAssinante }}</td>
              <td>{{ signer.sequenciaAssinante }}</td>
              <td>
                <p-tag
                  [severity]="signer.statusAssinante ? 'success' : 'danger'"
                  [value]="signer.statusAssinante ? 'Ativo' : 'Inativo'"
                >
                </p-tag>
              </td>
              <td>{{ signer.createdAt | date: 'dd/MM/yyyy' }}</td>
              <td>
                <div class="action-buttons">
                  <p-button
                    label="Editar"
                    icon="pi pi-pencil"
                    (onClick)="editSigner(signer.id)"
                    [disabled]="signer.deletedAt"
                    severity="info"
                    [outlined]="true"
                    size="small"
                    class="mr-2"
                  >
                  </p-button>

                  <p-button
                    [label]="signer.statusAssinante ? 'Inativar' : 'Ativar'"
                    [icon]="
                      signer.statusAssinante ? 'pi pi-pause' : 'pi pi-play'
                    "
                    (onClick)="toggleStatus(signer.id, signer.statusAssinante)"
                    [disabled]="signer.deletedAt"
                    [severity]="signer.statusAssinante ? 'warn' : 'success'"
                    [outlined]="true"
                    size="small"
                    class="mr-2"
                  >
                  </p-button>

                  <!--<p-button 
                                        label="Excluir" 
                                        icon="pi pi-trash" 
                                        (onClick)="deleteSigner(signer.id)"
                                        [disabled]="signer.deletedAt"
                                        severity="danger"
                                        [outlined]="true"
                                        size="small">
                                    </p-button>-->
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center p-4">
                <i class="pi pi-info-circle text-4xl text-400 mb-3"></i>
                <p class="text-600">Nenhum assinante encontrado</p>
                <p class="text-500 text-sm">
                  Tente ajustar os filtros ou adicione um novo assinante
                </p>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
    </p-card>

    <p-confirmDialog
      [acceptLabel]="'Sim'"
      [rejectLabel]="'Não'"
      acceptButtonStyleClass="p-button-success"
      rejectButtonStyleClass="p-button-secondary"
    >
    </p-confirmDialog>
    <p-toast></p-toast>
  `,
  styles: [
    `
      .filters-container {
        border-bottom: 1px solid #e0e0e0;
      }

      /* Alinhar filtros na mesma linha */
      .filters-container .p-grid {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;
      }

      .filters-container .p-col-12 {
        flex: 0 0 auto;
        min-width: 250px;
        max-width: 300px;
      }

      .action-buttons {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
      }

      .action-buttons .p-button {
        margin-right: 0;
        flex-shrink: 0;
      }

      :host ::ng-deep .p-datatable .p-datatable-tbody tr.opacity-50 {
        opacity: 0.5;
      }

      :host ::ng-deep .p-toolbar {
        border: none;
        padding: 1rem 0;
      }

      :host ::ng-deep .p-card .p-card-content {
        padding: 0;
      }

      :host ::ng-deep .p-datatable .p-datatable-loading-overlay {
        background: rgba(255, 255, 255, 0.8);
      }

      /* Diminuir altura das linhas da tabela */
      :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
        padding: 0.5rem;
        vertical-align: middle;
      }

      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        padding: 0.75rem 0.5rem;
        font-weight: 600;
      }

      /* Ajustar tamanho dos botões para ficarem compactos */
      :host ::ng-deep .action-buttons .p-button.p-button-small {
        padding: 0.375rem 0.75rem;
        font-size: 0.875rem;
      }

      /* Tags mais compactas */
      :host ::ng-deep .p-tag {
        padding: 0.25rem 0.5rem;
        font-size: 0.75rem;
      }

      @media (max-width: 768px) {
        .filters-container .p-grid {
          flex-direction: column;
          align-items: stretch;
          gap: 0.75rem;
        }

        .filters-container .p-col-12 {
          min-width: auto;
          width: 100%;
        }

        .action-buttons {
          flex-direction: column;
          gap: 0.25rem;
          align-items: stretch;
        }

        .action-buttons .p-button {
          width: 100%;
          justify-content: center;
        }

        :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
          padding: 0.75rem 0.5rem;
        }
      }

      @media (max-width: 480px) {
        /* Coluna de ações com largura reduzida em telas pequenas */
        :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td:last-child,
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th:last-child {
          width: 200px;
          min-width: 200px;
        }

        .action-buttons .p-button {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
        }
      }
    `,
  ],
})
export class SignersListComponent implements OnInit {
  signers: AssinanteResponseDTO[] = [];
  filteredSigners: AssinanteResponseDTO[] = [];
  searchTerm: string = '';
  statusFilter: string = '';
  pageSize = 10;
  isLoading = false;

  statusOptions = [
    { label: 'Ativo', value: 'active' },
    { label: 'Inativo', value: 'inactive' },
  ];

  constructor(
    private signerService: SignerService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.loadSigners();
  }

  loadSigners(): void {
    this.isLoading = true;
    this.signerService.listarTodos().subscribe({
      next: (response) => {
        //console.log('✅ Assinantes carregados:', response);
        this.signers = response;
        this.filterSigners();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('❌ Erro ao carregar assinantes:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar lista de assinantes',
        });
        this.isLoading = false;
        // Fallback com dados mock se necessário
        this.loadMockData();
      },
    });
  }

  private loadMockData(): void {
    // Dados mock para desenvolvimento
    this.signers = [
      {
        id: 1,
        nomeAssinante: 'João Silva',
        funcaoAssinante: 'Diretor',
        statusAssinante: true,
        sequenciaAssinante: 1,
        createdAt: '2024-01-15',
        updatedAt: '2024-01-15',
        deletedAt: undefined,
      },
      {
        id: 2,
        nomeAssinante: 'Maria Santos',
        funcaoAssinante: 'Gerente',
        statusAssinante: true,
        sequenciaAssinante: 2,
        createdAt: '2024-01-10',
        updatedAt: '2024-01-10',
        deletedAt: undefined,
      },
      {
        id: 3,
        nomeAssinante: 'Pedro Costa',
        funcaoAssinante: 'Coordenador',
        statusAssinante: false,
        sequenciaAssinante: 3,
        createdAt: '2024-01-05',
        updatedAt: '2024-01-05',
        deletedAt: undefined,
      },
    ];
    this.filterSigners();
  }

  filterSigners(): void {
    let filtered = this.signers;

    if (this.searchTerm) {
      filtered = filtered.filter(
        (signer) =>
          signer.nomeAssinante
            ?.toLowerCase()
            .includes(this.searchTerm.toLowerCase()) ||
          signer.funcaoAssinante
            ?.toLowerCase()
            .includes(this.searchTerm.toLowerCase()),
      );
    }

    if (this.statusFilter) {
      const isActive = this.statusFilter === 'active';
      filtered = filtered.filter(
        (signer) => signer.statusAssinante === isActive,
      );
    }

    this.filteredSigners = filtered;
  }

  createSigner(): void {
    this.router.navigate(['/home/signers/new']);
  }

  editSigner(id: number): void {
    this.router.navigate(['/home/signers/edit', id]);
  }

  toggleStatus(id: number, currentStatus: boolean): void {
    const action = currentStatus ? 'inativar' : 'ativar';
    const newStatus = !currentStatus;

    this.confirmationService.confirm({
      message: `Deseja ${action} este assinante?`,
      header: 'Confirmação',
      icon: 'pi pi-question-circle',
      accept: () => {
        this.signerService.alterarStatusEspecifico(id, newStatus).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: `Assinante ${action} com sucesso`,
            });
            this.loadSigners();
          },
          error: (error) => {
            // Fallback para o método original
            this.signerService.alterarStatus(id, newStatus).subscribe({
              next: () => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Sucesso',
                  detail: `Assinante ${action} com sucesso`,
                });
                this.loadSigners();
              },
              error: (fallbackError) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Erro',
                  detail: `Erro ao ${action} assinante`,
                });
              },
            });
          },
        });
      },
    });
  }

  deleteSigner(id: number): void {
    this.confirmationService.confirm({
      message:
        'Deseja realmente excluir este assinante? Esta ação não pode ser desfeita.',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        //console.log('🗑️ Excluindo assinante ID:', id);
        // Implementar serviço de exclusão quando disponível
        this.messageService.add({
          severity: 'info',
          summary: 'Exclusão',
          detail: 'Funcionalidade de exclusão será implementada',
        });
      },
    });
  }
}
